<template>
  <div>
    <page-header>
      <div class="text-nowrap text-dark ml-4 mr-3">
        <h4 class="form-check-label">
          {{ so.name }}
        </h4>
        <small class="font-weight-bold">{{so.type}}</small>
      </div>

      <router-link v-if="store.currentOccurrence.isCompleted" class="ml-1" :to="{ name: 'so-overview' }">
        <div class="badgebutton active text-nowrap c-white ml-2">
          <i class="far fa-caret-left"></i>
          Back to Special Occurrence overview
        </div>
      </router-link>

      <router-link v-if="!store.currentOccurrence.isCompleted" class="ml-1" :to="{ name: 'Boards' }">
        <div class="badgebutton active text-nowrap c-white ml-2">
          <i class="far fa-caret-left"></i>
          Back to landing page
        </div>
      </router-link>
    </page-header>

    <SpecialOccurrence />
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import SpecialOccurrence from '@/components/SpecialOccurrence/SpecialOccurrence.vue';
  import { LabelModule, LabelStore } from '@/store/label';
  import { SpecialOccurrenceDto } from '@/apiclient/apiclient_generated';

  @Component({
    components: {
      PageHeader,
      SpecialOccurrence,
    },
  })
  export default class SpecialOccurrenceComponent extends Vue {
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    private labelStore: LabelModule = LabelStore;

    get so() {
      return this.store.currentOccurrence;
    }

    async created() {
      await this.labelStore.getGeneralLabelsAsync();
    }

    beforeDestroy() {
      this.store.setCurrentOccurrence({} as SpecialOccurrenceDto);
    }
  }
</script>

<style lang="scss"></style>
